import React, { FC, useState, useEffect } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../constants/aampeTheme';

interface ImageProps {
    initialUrl: string;
    height?: string;
    width?: string;
    isCropped?: boolean;
}

interface StyleProps {
    height: string;
    width: string;
    isCropped: boolean;
}

const Image: FC<React.PropsWithChildren<ImageProps>> = ({
    initialUrl,
    height = '104px',
    width = '220px',
    isCropped = false,
}) => {
    const [isErrored, setIsErrored] = useState<boolean>(false);
    const backupImage =
        'https://storage.googleapis.com/assets.aampe.com/app_images/preview_assets/backup_image.png';

    const handleError = () => {
        setIsErrored(true);
    };

    useEffect(() => {
        setIsErrored(false);
    }, [initialUrl]);

    return (
        <ImageBanner
            src={!isErrored ? initialUrl : backupImage}
            onError={handleError}
            height={height}
            width={width}
            isCropped={isCropped}
        />
    );
};

export default Image;

const ImageBanner = styled.img.withConfig({
    shouldForwardProp: (prop) =>
        prop !== 'height' && prop !== 'width' && prop !== 'isCropped', // Exclude props from being forwarded to the DOM
})<StyleProps>(({ height, width, isCropped }) => ({
    height,
    width,
    borderRadius: aampeTheme.borderRadius.default,
    objectFit: isCropped ? 'cover' : 'contain',
}));
